import BackgroundImg from '../../../assets/images/splash-screen-background.jpg';
import Logo from '../../../assets/images/seascape_logo_white.svg';
import Loading from './Loading';
import { FC } from 'react';

const Splash: FC = () => {
	return (
		<div
			className="w-100 h-100 items-center justify-center"
			style={{
				backgroundImage: `url(${BackgroundImg})`,
				backgroundPosition: 'initial',
				position: 'absolute',
				backgroundAttachment: 'fixed',
				backgroundSize: 'cover',
				height: '100%',
				width: '100%',
			}}
		>
			<img src={Logo} className="splash-logo m-auto" alt="MSI Activity" />
			<div className="splash-loading">
				<Loading className="splash" text="LOADING" />
			</div>
		</div>
	);
};

export default Splash;
